export const LbEventType = {
  GOAL: 'GOAL',
  SUBSTITUTION: 'SUBSTITUTION',
  PENALTY: 'PENALTY',
  SHOT_BLOCKED: 'SHOT_BLOCKED',
  SHOT_WIDE: 'SHOT_WIDE',
  SHOT_ON_GOAL: 'SHOT_ON_GOAL',
  OFFSIDE: 'OFFSIDE',
  CORNER: 'CORNER',
  FOUL: 'FOUL',
  ASSIST: 'ASSIST',
  START_PHASE: 'START_PHASE',
  END_PHASE: 'END_PHASE',
  PAUSE: 'PAUSE',
  YELLOW_CARD: 'YELLOW_CARD',
  YELLOW_CARD_SECOND: 'YELLOW_CARD_SECOND',
  RED_CARD: 'RED_CARD',
  FREE_KICK: 'FREE_KICK',
  SAVE: 'SAVE',
  DISALLOWED_GOAL: 'DISALLOWED_GOAL',
  THROW_IN: 'THROW_IN',
  PASS: 'PASS',
  FAST_ATTACK: 'FAST_ATTACK',
  ATTACK: 'ATTACK',
  FULL_TIME: 'FULL_TIME',
  RESUME: 'RESUME',
  EXTRA_TIME: 'EXTRA_TIME',
  GOAL_OPPORTUNITY: 'GOAL_OPPORTUNITY',
  CHANGE_PHASE: 'CHANGE_PHASE',
  INJURY_TIME: 'INJURY_TIME',
  RED_YELLOW_CARD: 'RED_YELLOW_CARD',
  VAR_CHECK: 'VAR_CHECK',
  TACKLE: 'TACKLE',
  SOLO_RUN: 'SOLO_RUN',
  RECOVERED_BALL: 'RECOVERED_BALL',
  KICK_OFF: 'KICK_OFF',
  WARNING: 'WARNING',
  ORGANIZED_ATTACK: 'ORGANIZED_ATTACK',
  FAST_ACTION: 'FAST_ACTION',
  DROPPED_BALL: 'DROPPED_BALL',
  VAR: 'VAR',
  CORNER_AWARDED: 'CORNER_AWARDED',
  DANGEROUS_ATTACK: 'DANGEROUS_ATTACK',
  PENALTY_AWARDED: 'PENALTY_AWARDED',
} as const;
export type LbEventType = (typeof LbEventType)[keyof typeof LbEventType];

export const LbEventSubType = {
  PENALTY_SECOND_MARK: 'PENALTY_SECOND_MARK',
  OWN: 'OWN',
  PENALTY: 'PENALTY',
  MISSED: 'MISSED',
  SCORED: 'SCORED',
  BAR: 'BAR',
  POST: 'POST',
  HANDBALL: 'HANDBALL',
  SIMULATION: 'SIMULATION',
  FULL_TIME: 'FULL_TIME',
  PAUSED: 'PAUSED',
  SUSPENDED: 'SUSPENDED',
  TIMEOUT: 'TIMEOUT',
  FOUL_PLAY: 'FOUL_PLAY',
  ROUGH_PLAY: 'ROUGH_PLAY',
  TRIP_OPPONENT: 'TRIP_OPPONENT',
  FOUL_PLAYROUGH_PLAY: 'FOUL_PLAYROUGH_PLAY',
  DANGEROUS_PLAY: 'DANGEROUS_PLAY',
  TIME_WASTING: 'TIME_WASTING',
  KICKING_BALL_AWAY: 'KICKING_BALL_AWAY',
  HOLDING_OPPONENT: 'HOLDING_OPPONENT',
  IMPROPER_CONDUCT: 'IMPROPER_CONDUCT',
  DISSENT: 'DISSENT',
  PUSHING_OPPONENT: 'PUSHING_OPPONENT',
  FREE_KICK_DISTANCE: 'FREE_KICK_DISTANCE',
  CHARGING_OPPONENT: 'CHARGING_OPPONENT',
  VIOLENT_PLAY: 'VIOLENT_PLAY',
  ENTERING_WITHOUT_PERMISSION: 'ENTERING_WITHOUT_PERMISSION',
  DIRECT_FREE_KICK: 'DIRECT_FREE_KICK',
  INDIRECT_FREE_KICK: 'INDIRECT_FREE_KICK',
  GOALKEEPER: 'GOALKEEPER',
  FREE_KICK: 'FREE_KICK',
  CORNER: 'CORNER',
  CROSS: 'CROSS',
  FAST_ATTACK: 'FAST_ATTACK',
  WOODWORK: 'WOODWORK',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CAUSING_GOAL: 'CAUSING_GOAL',
  HALF_TIME: 'HALF_TIME',
  SAVED: 'SAVED',
  CROSSBAR: 'CROSSBAR',
  WIDE: 'WIDE',
  GOAL_KICK: 'GOAL_KICK',
  LONG: 'LONG',
  MEDIUM: 'MEDIUM',
  CLEARANCE: 'CLEARANCE',
  SHORT: 'SHORT',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  CENTER: 'CENTER',
} as const;
export type LbEventSubType = (typeof LbEventSubType)[keyof typeof LbEventSubType];

export const LbEventPhase = {
  FIRST_HALF: 'FIRST_HALF',
  SECOND_HALF: 'SECOND_HALF',
  EXTRA_TIME_FIRST_HALF: 'EXTRA_TIME_FIRST_HALF',
  EXTRA_TIME_SECOND_HALF: 'EXTRA_TIME_SECOND_HALF',
  PENALTY: 'PENALTY',
} as const;
export type LbEventPhase = (typeof LbEventPhase)[keyof typeof LbEventPhase];
